import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/Services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { SalService } from 'src/app/Services/sal/sal.service';
import * as moment from 'moment';

@Component({
  selector: 'app-payout-history',
  templateUrl: './payout-history.component.html',
  styleUrls: ['./payout-history.component.css']
})
export class PayoutHistoryComponent implements OnInit {


  Submitted: boolean = false;
  Action: any = "Add";
  constructor(private salservice: SalService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) {


  }
 

  SearchModel = {
    PartnerID: 0,
    ToDate: '',
    FromDate: '',
    CurrentIndex: 0,
    PageSize: 20
  };

  ClearSearch() {
    this.SearchModel.PartnerID = 0;
    this.SearchModel.FromDate = '';
    this.SearchModel.ToDate = '';
    this.PayoutHistoryList = [];
  }

  PayoutHistoryList = [];
  GetAllPayoutHistory() {
    this.SearchModel.CurrentIndex = this.currentPage;
    this.SearchModel.PageSize = this.pageSize;
    this.spinnerService.show();
    this.SearchModel.FromDate =this.SearchModel.FromDate!=null && this.SearchModel.FromDate!=''?moment(this.SearchModel.FromDate).format('DD-MMM-YYYY'):'';
    this.SearchModel.ToDate =this.SearchModel.ToDate!=null && this.SearchModel.ToDate!=''?moment(this.SearchModel.ToDate).format('DD-MMM-YYYY'):'';
   
    this.salservice.GetAllPayoutHistory(JSON.stringify(this.SearchModel)).subscribe((response: any) => {
      this.PayoutHistoryList = response.PayoutHistoryList;
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(response);
      this.recordCount = 0;
      if (response.PayoutHistoryList != null && response.PayoutHistoryList.length > 0) {
        this.recordCount = response.PayoutHistoryList[0].RecordCount;
      }
      this.numberOfPages();
    });
  };


  
  ngOnInit() {    
    this.GetAllPartner();
    this.GetAllPayoutHistory();
  }
  

  PartnerList: any;
  GetAllPartner() {   
    this.lookupservice.GetLookupsList('Partner','').subscribe((data: any) => {
      this.PartnerList = data.LookupItems;

    });
  };
 
 
  // Paging

  currentPage = 1;
  pageSize = 20;
  recordCount = 0;
  totalPages = 0;
  numberOfPages() {
    this.totalPages = Math.ceil(this.recordCount / this.pageSize);
  }

  nextPage() {
    this.currentPage = this.currentPage + 1;
  }

  pageSizes() {
    this.currentPage = 1;
    this.recordCount = 0;
    this.totalPages = 0;
  }



  


}



